import { useMutation } from '@tanstack/react-query';

import { trafficSourceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

const validateTrafficSourceKey: trafficSourceTypes.ValidateTrafficSourceKey = (
  data
): Promise<{ exists: boolean }> => {
  return axios.post(`/traffic-sources/keys/validate`, data);
};

type ValidateTrafficSourceKeyOptions = {
  config?: MutationConfig<typeof validateTrafficSourceKey>;
};

export function useValidateTrafficSourceKey({ config = {} }: ValidateTrafficSourceKeyOptions = {}) {
  return useMutation({
    ...config,
    mutationFn: validateTrafficSourceKey,
  });
}
